import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { Heading } from '../../components/heading';
import { Text } from '../../components/text';
import { Button } from '../../components/button';

const BillingCancel = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/app/config');
  };

  const handleGoBack = () => {
    navigate('/app/config');
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
          <XCircleIcon className="w-8 h-8 text-gray-500" />
        </div>
        <Heading level={2} className="text-xl font-bold text-azul-surelia mb-3">
          Checkout cancelado
        </Heading>
        <Text className="text-azul-surelia/70 mb-6">
          El proceso de suscripción fue cancelado. No se realizó ningún cargo a tu
          tarjeta. Puedes intentar de nuevo cuando quieras.
        </Text>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleRetry}>
            Intentar de nuevo
          </Button>
          <Button outline onClick={handleGoBack}>
            Volver a configuración
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BillingCancel;
